import { render, staticRenderFns } from "./ProductCatalog.html?vue&type=template&id=333904d2&scoped=true&external"
import script from "./ProductCatalog.js?vue&type=script&lang=js&external"
export * from "./ProductCatalog.js?vue&type=script&lang=js&external"
import style0 from "./ProductCatalog.scss?vue&type=style&index=0&id=333904d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333904d2",
  null
  
)

export default component.exports